import bem from 'utils/bem';

export const block = bem('chips-list');
